(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-purchase-options"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.ppo').forEach(function (root) {
    var sid = root.dataset.sid;
    var data = window['ppo_' + sid];
    if (!data) return;

    var vidInput = root.querySelector('[data-ppo-vid]');
    var planInput = root.querySelector('[data-ppo-plan]');
    var pills = Array.from(root.querySelectorAll('.ppo__pill'));
    var radios = Array.from(root.querySelectorAll('.ppo__radio'));
    var opts = Array.from(root.querySelectorAll('.ppo__opt'));
    var ci = 0;

    function fmt(cents) {
      return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function set(sel, val) {
      var el = root.querySelector(sel);
      if (el) el.textContent = val;
    }

    function vis(sel, show) {
      var el = root.querySelector(sel);
      if (el) el.style.visibility = show ? '' : 'hidden';
    }

    function updatePrices() {
      var v = data.variants[ci];
      if (!v) return;
      vidInput.value = v.id;
      var days = v.qty * data.days;

      set('[data-ppo-op]', fmt(v.price));
      if (v.cmp > v.price) {
        set('[data-ppo-ow]', fmt(v.cmp));
        vis('[data-ppo-ow]', true);
      } else {
        vis('[data-ppo-ow]', false);
      }
      set('[data-ppo-opd]', fmt(Math.round(v.price / days)) + '/día');
      set('[data-ppo-otf]', v.qty + ' ' + (v.qty === 1 ? 'bote' : 'botes') + ', entrega una sola vez');

      if (v.sub) {
        set('[data-ppo-sp]', fmt(v.sub.p));
        if (v.sub.c > v.sub.p) {
          set('[data-ppo-sw]', fmt(v.sub.c));
          vis('[data-ppo-sw]', true);
        } else {
          vis('[data-ppo-sw]', false);
        }
        set('[data-ppo-spd]', fmt(Math.round(v.sub.p / days)) + '/día');
      }
    }

    function updateType(type) {
      opts.forEach(function (opt) {
        opt.classList.toggle('ppo__opt--sel', opt.dataset.pt === type);
      });
      if (type === 'subscription' && data.planId) {
        planInput.disabled = false;
        planInput.value = data.planId;
      } else {
        planInput.disabled = true;
        planInput.value = '';
      }
    }

    pills.forEach(function (pill, i) {
      pill.addEventListener('click', function () {
        ci = i;
        pills.forEach(function (p, j) {
          p.classList.toggle('ppo__pill--on', j === i);
          p.setAttribute('aria-pressed', j === i ? 'true' : 'false');
        });
        updatePrices();
      });
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateType(radio.value);
      });
    });

    updatePrices();
    updateType('onetime');
  });
})();

  } catch(e) { console.error(e); }
})();
})();
